// extracted by mini-css-extract-plugin
export var chevronIcon = "_cg-2";
export var teamName = "_cg-1";
export var teamSwitcherButton = "_cg-0";